<template>
    <div>
        <div class="row justify-content-center">
            <div>
                <h4 v-if="date">{{ $t('eventos.calendario_fecha') }} {{ dateText }}</h4>
                <h4 v-else>{{ $t('eventos.calendario_seleccione_dia') }}</h4>
            </div>
        </div>
        <div class="row justify-content-center mt-4">
            <vc-date-picker mode="date" v-model="date" :attributes="attributes" :model-config="modelConfig"
                :available-dates="available" @dayclick="getSesiones" ref="calendar"/>
        </div>
        <ListadoSessiones v-if="sesiones.length > 0" :event="event" :sesiones="sesiones"></ListadoSessiones>
    </div>

</template>

<script>
import ListadoSessiones from '@/components/frontend/events/ListadoSessiones';
export default {
    props: ['event'],
    data() {
        return {
            date: null,
            modelConfig: {
                type: 'string',
                mask: 'YYYY-MM-DD',
            },
            sesiones: [],
        }
    },
    mounted() {
        this.getPrimerDate();
    },
    computed: {
        attributes() {
            var data = [
                {
                    dates: [],
                },
                {
                    dates: [],
                }
            ]
            this.event.sesiones.forEach(sesion => {
                if (sesion.entradas_libres) {
                    data[0].dates.push(new Date(sesion.session_date))
                    data[0].popover = { label: 'Hay sesiones disponibles' }
                    data[0].dot = {
                        color: 'green',
                    }
                } else {
                    data[1].dates.push(new Date(sesion.session_date))
                    data[1].popover = { label: 'No hay sesiones disponibles' }
                    data[1].dot = {
                        color: 'red',
                    }
                }
            });


            data[0].dates.forEach(element => {
                data[1].dates.forEach(element2 => {
                    var day1 = moment(element).day();
                    var day2 = moment(element2).day();
                    var month1 = moment(element).month();
                    var month2 = moment(element2).month();
                    var year1 = moment(element).year();
                    var year2 = moment(element2).year();
                    
                    if (day1 == day2 && month1 == month2 && year1 == year2) {
                        data[1].dates.splice(data[0].dates.indexOf(element), 1);
                    }

                });
            });

            return data
        },
        available() {
            var data = []

            this.event.sesiones.forEach(sesion => {
                data.push({
                    start: new Date(sesion.session_date),
                    end: new Date(sesion.session_date)
                })
            });
            return data
        },
        dateText() {
            var fecha = new Date(this.date);
            var dia = fecha.getDate();
            var mesNumero = fecha.getMonth();

            // Crear un arreglo de nombres de meses
            var meses = [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre"
            ];

            // Obtener el mes en texto
            var mesTexto = meses[mesNumero];

            // Obtener el año (número)
            var ano = fecha.getFullYear();

            return dia + " de " + mesTexto + " de " + ano;
        },
    },
    methods: {
        getSesiones() {
            this.sesiones = [];
            var fecha = new Date(this.date);
            const inicioDelDia = fecha.setHours(0, 0, 0, 0);
            const finalDelDia = fecha.setHours(23, 59, 59, 999);

            this.event.sesiones.forEach(sesion => {
                if (new Date(sesion.session_date) >= new Date(inicioDelDia) && new Date(sesion.session_date) <= new Date(finalDelDia)) {
                    this.sesiones.push(sesion)
                }
            });
        },
        getPrimerDate(){
            var fecha = moment(this.event.sesiones[0].session_date);

            var mes = parseInt(fecha.format('M'));
            var ano = parseInt(fecha.format('YYYY'));

            const calendar = this.$refs.calendar
            calendar.move({ month: mes, year: ano })
        }
    },
    components: { ListadoSessiones }
}

</script>